//import { sendMessage } from './debugMsg.js';
//import { phoneMask } from './phoneMask.js';
//import { seminarChoice } from './seminarChoice.js';
//import { inputRule } from './inputRule.js';

export const modalHide = () => {
  const modals = Array.from(document.querySelectorAll('[data-modal]'));
  const modalSuccess = document.getElementById('modal-success');
  const formModals = modals.filter((m) => m.querySelector('[data-form-validate]'));
  const info = document.querySelector('#info');
  const choice = document.querySelector('#choice');
  const promoInput = document.querySelector('#promoInput');
  const errorSemChoice = document.querySelector('#errorSemChoice');

  // Конфиг многошаговых модалок и их "шаг 2" шаблонов
  const multiStepConfig = {
    'modal-one': { detailsId: 'modal-one-details' },
    'modal-two': { detailsId: 'modal-two-details' },
  };

  // Сохраняем исходный HTML блока для шага 1, чтобы уметь откатиться
  const initialBlocks = new Map();
  Object.keys(multiStepConfig).forEach((id) => {
    const modal = document.getElementById(id);
    if (!modal) return;
    const block = modal.querySelector('.modal-promo__block');
    if (block) {
      initialBlocks.set(id, block.innerHTML);
    }
  });

  const footerForm = document.querySelector('.footer [data-form-validate]');
  if (footerForm) {
    footerForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const submitBtn = this.querySelector('.footer__btn');
      if (submitBtn && !submitBtn.disabled) {
        handleSubmit(submitBtn, this, false, true, 'question');
      }
    });
  }

  const reinitModalEnhancements = (modal) => {
    if (!modal) return;

    // Сбрасываем флаг инициализации маски телефона для копий полей внутри этой модалки
    modal.querySelectorAll('.footer-input__phone').forEach((input) => {
      input.removeAttribute('data-phone-mask-inited');
    });

    // Переинициализируем выбор семинаров, маску телефона и валидацию только в рамках этой модалки
    seminarChoice(modal);
    phoneMask(modal);
    inputRule(modal);
  };

  const collectFormData = (container, explicitContext = null) => {
    const getVal = (selector) => {
      const el = container.querySelector(selector);
      return el ? el.value.trim() : '';
    };
    console.log(container);
    console.log(explicitContext);

    const data = {
      surname: getVal('.footer-input__surname, .modal-input[placeholder*="Фамилия"]'),
      name: getVal('.footer-input__name, .modal-input[placeholder*="Имя"]'),
      phone: getVal('.footer-input__phone, .modal-input[placeholder*="телефон"]'),
      email: getVal('.footer-input__mail, .modal-input[placeholder*="почта"]'),
    };

    const promoField = container.querySelector('.modal-input[placeholder*="промокод"]');
    if (promoField && promoInput.style.display != 'none') data.promo = promoField.value.trim();

    const msgField = container.querySelector('.footer-input__textarea');
    if (msgField) data.message = msgField.value.trim();

    if(container.id == 'modal-promo'){
      data.seminarsChoice = seminarsChoice;
    }

    // Контекст: если передан явно – используем, иначе берём из dataset модалки
    if (explicitContext) {
      data.context = explicitContext;
    } else if (container.dataset && container.dataset.requestContext) {
      data.context = container.dataset.requestContext;
    }

    return data;
  };

  const clearFormFields = (container, dispatchEvents = false) => {
    if (!container) return;
    container.querySelectorAll('input[type="text"], input[type="number"], input[type="email"], textarea').forEach((el) => {
      el.value = '';
      if (dispatchEvents) el.dispatchEvent(new Event('input', { bubbles: true }));
    });
    container.querySelectorAll('input[type="checkbox"]').forEach((el) => {
      el.checked = false;
      if (dispatchEvents) el.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const openModal = (modal) => {
    if (!modal) return;

    // Для многошаговых модалок при каждом открытии откатываемся на шаг 1
    if (initialBlocks.has(modal.id)) {
      const block = modal.querySelector('.modal-promo__block');
      const initialHtml = initialBlocks.get(modal.id);
      if (block && typeof initialHtml === 'string') {
        block.innerHTML = initialHtml;
      }
    }

    // После восстановления исходного содержимого переинициализируем обработчики внутри модалки
    reinitModalEnhancements(modal);

    // Скрываем ошибку при открытии модалки
    const formContainer = modal.querySelector('[data-form-validate]');
    if (formContainer) {
      hideError(formContainer);
    }

    modal.classList.remove('none');
    document.body.style.overflow = 'hidden';
  };

  const closeModal = (modal) => {
    if (!modal) return;

    if (initialBlocks.has(modal.id)) {
      resetModalContent(modal);

      if (typeof seminarsChoiceNum !== 'undefined') seminarsChoiceNum = 0;
      if (info) info.style.display = 'none';
      if (choice) choice.style.display = 'block';
      if (promoInput) promoInput.style.display = 'block';
      if (errorSemChoice) errorSemChoice.classList.remove('active');
    }

    if (formModals.includes(modal)) {
      clearFormFields(modal);
      // Скрываем ошибку при закрытии модалки
      const formContainer = modal.querySelector('[data-form-validate]');
      if (formContainer) {
        hideError(formContainer);
      }
    }
    modal.classList.add('none');
    const hasOpenModal = modals.some((m) => m && !m.classList.contains('none'));
    if (!hasOpenModal) {
      document.body.style.overflow = '';
    }
  };

  const closeAllModals = () => {
    modals.forEach(closeModal);
    document.body.style.overflow = '';
  };

  const hideError = (container) => {
    const errorSpan = container.querySelector('.footer-button__block .legal-2');
    if (errorSpan) {
      errorSpan.textContent = '';
      errorSpan.classList.remove('active');
    }
  };

  const switchModalContent = (currentModal, detailsModalId) => {
    if (!currentModal || !detailsModalId) return;
    const detailsModal = document.getElementById(detailsModalId);
    if (!detailsModal) return;

    const currentBlock = currentModal.querySelector('.modal-promo__block');
    const detailsBlock = detailsModal.querySelector('.modal-promo__block');

    if (!currentBlock || !detailsBlock) return;

    // Заменяем содержимое шага в текущей модалке на содержимое из модалки-шаблона
    currentBlock.innerHTML = detailsBlock.innerHTML;

    // Переинициализируем обработчики внутри модалки после подмены контента
    reinitModalEnhancements(currentModal);
  };

  const resetModalContent = (modal) => {
    if (!modal || !initialBlocks.has(modal.id)) return;
    const initialHtml = initialBlocks.get(modal.id);
    const block = modal.querySelector('.modal-promo__block');
    if (block && typeof initialHtml === 'string') {
      block.innerHTML = initialHtml;
      // После отката шага 1 снова навешиваем обработчики внутри модалки
      reinitModalEnhancements(modal);
    }
  };

  const handleSubmit = async (btn, container, closeAfterSuccess = true, clearAfterSuccess = true, explicitContext = null) => {
    if (btn.disabled) return;

    // Проверяем валидность формы через data-атрибут
    if (container.dataset.formValid === 'false') {
      // Форма невалидна - не отправляем
      return;
    }

    const formData = collectFormData(container, explicitContext);
    console.log(formData);
    //return;

    // Определяем action для reCAPTCHA в зависимости от контекста
    const recaptchaAction = explicitContext === 'question' ? 'question' : 'seminar_registration';

    btn.disabled = true;

    try {
      // Получаем токен reCAPTCHA
      const token = await getRecaptchaToken(recaptchaAction);
      formData.recaptcha_token = token;

      const success = await sendMessage(formData);

      if (success) {
        // Скрываем ошибку при успешной отправке
        hideError(container);
        if (clearAfterSuccess) {
          clearFormFields(container, true);
        }
        if (closeAfterSuccess) {
          const currentModal = container.closest('[data-modal]');
          if (currentModal) closeModal(currentModal);
          closeAllModals();
          openModal(modalSuccess);
        }
      } else {
        alert('Не удалось отправить заявку. Попробуйте позже.');
      }
    } catch (error) {
      console.error('Ошибка при отправке или reCAPTCHA:', error);
      alert('Не удалось отправить заявку. Попробуйте позже.');
    } finally {
      btn.disabled = false;
    }
  };

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-modal-open]');
    if (openBtn) {
      e.preventDefault();
      const targetId = openBtn.getAttribute('data-modal-open');
      const targetModal = document.getElementById(targetId);
      if (targetModal) {
        // Определяем контекст (название семинара или тип заявки)
        let context = '';
        const seminarCard = openBtn.closest('.seminar-card');
        if (seminarCard) {
          const titleEl = seminarCard.querySelector('.seminar-panel__title');
          if (titleEl) context = titleEl.textContent.trim();
        }
        const priceCard = openBtn.closest('.price-card');
        if (priceCard) {
          const priceTextEl = priceCard.querySelector('.price-card__text');
          if (priceTextEl) context = priceTextEl.textContent.trim();
        }
        targetModal.dataset.requestContext = context || 'Запись';

        closeAllModals();
        openModal(targetModal);
      }
      return;
    }

    // Обработчик клика на крестик (SVG в modal-promo__icon)
    const modalIcon = e.target.closest('.modal-promo__icon');
    if (modalIcon) {
      const modal = modalIcon.closest('[data-modal]');
      if (modal) {
        e.preventDefault();
        closeModal(modal);
      }
      return;
    }

    // Кнопки "Изменить" / "Назад" во вторых шагах должны вернуть первый шаг
    const backOrChangeBtn = e.target.closest('.modal-choice__details-btn, .modal-promo__exit-text');
    if (backOrChangeBtn) {
      const currentModal = backOrChangeBtn.closest('[data-modal]');
      if (currentModal) {
        e.preventDefault();
        resetModalContent(currentModal);
        info.style.display = 'none';
        choice.style.display = 'block';
      }
      return;
    }

    const modalSubmitBtn = e.target.closest('.modal-submit-btn');
    if (modalSubmitBtn && !modalSubmitBtn.disabled) {
      const currentModal = modalSubmitBtn.closest('[data-modal]');
      if (currentModal) {
        const step = modalSubmitBtn.dataset.step;

        // Шаг 1: просто меняем контент в текущей модалке, не открывая новую
        if (step === '1') {
          e.preventDefault();

          if (seminarsChoiceNum) {
            errorSemChoice.classList.remove('active');
            promoInput.style.display = seminarsChoiceNum > 1 ? 'none' : 'block';
            choice.style.display = 'none';
            info.style.display = 'block';

            reinitModalEnhancements(currentModal);
          } else {
            errorSemChoice.textContent = 'Выберите хотябы один семинар';
            errorSemChoice.classList.add('active');
          }
          /*
          if (currentModal.id === 'modal-one') {
            switchModalContent(currentModal, 'modal-one-details');
          } else if (currentModal.id === 'modal-two') {
            switchModalContent(currentModal, 'modal-two-details');
          }
          */

          return;
        }

        // Финальный шаг: отправка формы
        e.preventDefault();
        handleSubmit(modalSubmitBtn, currentModal, true, true);
      }
      return;
    }

    const modalOverlay = e.target.closest('[data-modal]');
    if (modalOverlay && !e.target.closest('.modal-promo__block') && !e.target.closest('.modal-promo__box')) {
      closeModal(modalOverlay);
    }
  });

  const getRecaptchaToken = (action) => {
    return new Promise((resolve, reject) => {
      if (typeof grecaptcha === 'undefined' || typeof grecaptcha.execute !== 'function') {
        reject(new Error('reCAPTCHA не загружена'));
        return;
      }
      grecaptcha.ready(() => {
        grecaptcha.execute(window.RECAPTCHA_SITE_KEY, { action: action })
            .then(resolve)
            .catch(reject);
      });
    });
  };

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const openModalEl = modals.find((m) => m && !m.classList.contains('none'));
      if (openModalEl) closeModal(openModalEl);
    }
  });
};
